export const fileFormats = ['.pdf', '.jpg', '.jpeg', '.gif', '.png'];

export const fileCategories = ['Lékařská zpráva', 'Výsledek laboratorního vyšetření', 'Jiný druh dokumentu'];
export const defaultFileCategory = 'Lékařská zpráva'
